import React, { memo } from "react";
import PropTypes from "prop-types";
import { Stack, Button, Icon, Chip, Divider } from "investira.react.components";

const RelatoriosContextActions = memo((props) => {
  function handleUploadClick() {
    props.onUploadClick && props.onUploadClick();
  }

  return (
    <Stack justifyContent="center" sx={{ height: "40px" }}>
      <Stack direction="row" alignItems="center">
        <Stack direction="row" spacing={1.5}>
          <Button
            disabled={props.disabled}
            variant="contained"
            color="primary"
            startIcon={<Icon iconName="download" size={16} />}
            size="small"
            sx={{ px: 2 }}
          >
            Download
          </Button>
          <Divider orientation="vertical" flexItem />
          <Button
            disabled={props.disabled}
            variant="contained"
            color="error"
            startIcon={<Icon iconName="delete" size={16} />}
            size="small"
            sx={{ px: 2 }}
          >
            Excluir
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
});

RelatoriosContextActions.propTypes = {};

export default RelatoriosContextActions;
